//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DisableLockedSaving: FeatureFlag = {"Id":"DisableLockedSaving","Label":"(Performance) Disable guaranteeing saves happen in order ","Impact":"Normally, the system processing page saves in order. When this is enabled, this check is omitted with the impact that older saves can overwrite data from later saves.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
